/**
 * @generated SignedSource<<a7cc68585eeff270beb77c3e27e10147>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScreenersRecruitStatusChoices = "F" | "NS" | "P" | "S" | "%future added value";
export type ResumeRecruitInput = {
  clientMutationId?: string | null;
  recruitId: string;
};
export type RecruitTitle_resumeRecruit_Mutation$variables = {
  input: ResumeRecruitInput;
};
export type RecruitTitle_resumeRecruit_Mutation$data = {
  readonly resumeRecruit: {
    readonly recruit: {
      readonly id: string;
      readonly status: ScreenersRecruitStatusChoices;
    } | null;
  } | null;
};
export type RecruitTitle_resumeRecruit_Mutation = {
  response: RecruitTitle_resumeRecruit_Mutation$data;
  variables: RecruitTitle_resumeRecruit_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ResumeRecruitPayload",
    "kind": "LinkedField",
    "name": "resumeRecruit",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitNode",
        "kind": "LinkedField",
        "name": "recruit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecruitTitle_resumeRecruit_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecruitTitle_resumeRecruit_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3e878d22e17fe4d57e708c804f9bb1fe",
    "id": null,
    "metadata": {},
    "name": "RecruitTitle_resumeRecruit_Mutation",
    "operationKind": "mutation",
    "text": "mutation RecruitTitle_resumeRecruit_Mutation(\n  $input: ResumeRecruitInput!\n) {\n  resumeRecruit(input: $input) {\n    recruit {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c6f6b4681fd6c0d736bd3cdf9836a01";

export default node;
